// extracted by mini-css-extract-plugin
export default {"container":"UploadCSV_container__wPVEN","dragging":"UploadCSV_dragging__WTj8D","text":"UploadCSV_text__fi3Yf"};